// $.validator.addMethod("regex", function (value, element, regexp) {
//     if (regexp && regexp.constructor != RegExp) {
//         regexp = new RegExp(regexp);
//     } else if (regexp.global) regexp.lastIndex = 0;
//     return this.optional(element) || regexp.test(value);
// });

// $.validator.addMethod(
//     "notEqualTo",
//     function (value, element, param) {
//         var notEqual = true;
//         value = $.trim(value);
//         for (i = 0; i < param.length; i++) {
//             if (value == $.trim($(param[i]).val())) {
//                 notEqual = false;
//             }
//         }
//         return this.optional(element) || notEqual;
//     },
//     "Please enter a diferent value."
// );

// if ($("html").attr("lang") === "th") {
//     $.extend($.validator.messages, {
//         required: "โปรดระบุ",
//         remote: "โปรดแก้ไขให้ถูกต้อง",
//         email: "โปรดระบุที่อยู่อีเมล์ที่ถูกต้อง",
//         url: "โปรดระบุ URL ที่ถูกต้อง",
//         date: "โปรดระบุวันที่ ที่ถูกต้อง",
//         dateISO: "โปรดระบุวันที่ ที่ถูกต้อง (ระบบ ISO).",
//         number: "โปรดระบุทศนิยมที่ถูกต้อง",
//         digits: "โปรดระบุจำนวนเต็มที่ถูกต้อง",
//         creditcard: "โปรดระบุรหัสบัตรเครดิตที่ถูกต้อง",
//         equalTo: "โปรดระบุค่าเดิมอีกครั้ง",
//         extension: "โปรดระบุค่าที่มีส่วนขยายที่ถูกต้อง",
//         maxlength: $.validator.format("โปรดอย่าระบุค่าที่ยาวกว่า {0} อักขระ"),
//         minlength: $.validator.format("โปรดอย่าระบุค่าที่สั้นกว่า {0} อักขระ"),
//         rangelength: $.validator.format(
//             "โปรดอย่าระบุค่าความยาวระหว่าง {0} ถึง {1} อักขระ"
//         ),
//         range: $.validator.format("โปรดระบุค่าระหว่าง {0} และ {1}"),
//         max: $.validator.format("โปรดระบุค่าน้อยกว่าหรือเท่ากับ {0}"),
//         min: $.validator.format("โปรดระบุค่ามากกว่าหรือเท่ากับ {0}"),
//     });
// }

// $(function () {
//     if ($("[data-slick]").length > 0) {
//         $("[data-slick]").slick();
//     }
// });

require("./_signup_form");
require("./_share");
